import React from 'react';
import { Field, useField } from 'formik'; // Import useField from Formik

interface WeightInputProps {}

const WeightInput: React.FC<WeightInputProps> = () => {
    const [field, meta] = useField('weight'); // Use useField hook to get field and meta

    return (
        <tr>
            <th>Kauba kaal:</th>
            <td style={{ verticalAlign: 'bottom' }}>
                <input
                    {...field}
                    id="weight"
                    className="small"
                    type="number"
                    step="1"
                />{' '}
                kg
                <br />
                Ei tea{' '}
                <Field
                    name="noWeight"
                    type="checkbox"
                />
            </td>
        </tr>
    );
};

export default WeightInput;